export default __webpack_public_path__ + "static/media/k_p_img2.8cab79f3.JPG";